<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { isAInboxViewRoute } from 'dashboard/helper/routeHelpers';

const notificationMetadata = useMapGetter('notifications/getMeta');
const route = useRoute();
const router = useRouter();
const { accountScopedRoute } = useAccount();

const unreadCount = computed(() => {
  if (!notificationMetadata.value.unreadCount) {
    return '';
  }

  return notificationMetadata.value.unreadCount < 100
    ? `${notificationMetadata.value.unreadCount}`
    : '99+';
});

const isActive = computed(() => isAInboxViewRoute(route.name, true));

function openNotifications() {
  if (!isActive.value) {
    router.push(accountScopedRoute('inbox_view'));
  }
}
</script>

<template>
  <button
    class="size-8 rounded-lg flex-shrink-0 grid place-content-center relative"
    :class="
      isActive
        ? 'text-n-slate-12 bg-n-alpha-2'
        : 'text-n-slate-11 hover:bg-n-alpha-1'
    "
    @click="openNotifications"
  >
    <span class="i-lucide-bell size-4" />
    <span
      v-if="unreadCount"
      class="min-h-4 min-w-4 px-1 bg-n-ruby-9 rounded-full absolute -top-1.5 -right-2 grid place-items-center text-[10px] font-bold leading-none text-white shadow-md"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
